// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';

const FourOhFour = () => {

    return (
        <div>
            404, Page Not Found.
        </div>
    );
}

export default FourOhFour;